import type { ClientInfoFromBackend } from 'app/api/services/client/client-info/types';

export const USER_FULL_NAME_STORAGE_KEY = 'user-full-name-storage';

type FullName = Pick<ClientInfoFromBackend, 'firstName' | 'middleName' | 'lastName' | 'fullName'>;
type Callback = (fullName: FullName) => void;

function removeUserFullNameFromStorage() {
  localStorage.removeItem(USER_FULL_NAME_STORAGE_KEY);
}

export function saveUserFullNameToStorage(fullName: FullName) {
  localStorage.setItem(USER_FULL_NAME_STORAGE_KEY, JSON.stringify(fullName));
}

export function listenStorage(callback: Callback) {
  window.addEventListener('storage', getFullNameFromStorageEvent(callback));
}

export function removeStorageListener() {
  window.removeEventListener('storage', getFullNameFromStorageEvent());
}

function getFullNameFromStorageEvent(callback?: Callback) {
  return (event: StorageEvent) => {
    if (event.key !== USER_FULL_NAME_STORAGE_KEY || event.newValue === null) {
      return;
    }

    // TODO: это событие (с ключом USER_FULL_NAME_STORAGE_KEY) вызывается два раза
    // Если будет скучно, можно поизучать этот момент и понять почему так происходит
    //
    // UPD: происходит из-за того, что storageListener сработал сразу на двух вкладках
    // На той, которая отправила данные и на той, которая принимала данные
    // Та, которая отправила, не должна отслеживать свой запрос
    // Можно дополнительно в ключ (USER_FULL_NAME_STORAGE_KEY) сохранять tabId
    // Похожая логика уже реализована в authChannel.ts

    callback && callback(JSON.parse(event.newValue));
    removeUserFullNameFromStorage();
    removeStorageListener();
  };
}
